import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import Form01 from "./form/Form01";
import "./styles/print.stye.css";
import Form02 from "./form/Form02";
import Form03 from "./form/Form03";
import Form04 from "./form/Form04";
import Form05 from "./form/Form05";
import Form07 from "./form/Form07";
import Form08 from "./form/Form08";
import Form09 from "./form/Form09";
import Form10 from "./form/Form10";
import Form11 from "./form/Form11";
import Form06 from "./form/Form06";
import { OnlineLeaveSubmissionApi } from "../../../../api/online-leave-submission/online-leave-submission.api";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import { getToken } from "../../../../utils/app.utils";
import { calculateLeavePeriod } from "../../../../utils/calculatePeriod";
import moment from "moment";

const PrintOnlineLeaveSubmission = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const formType = queryParams.get("form");

  const { id, token } = useParams();
  const local_token: string | undefined | null = getToken();

  const leave_id = id ? parseInt(id) : id;

  const [dataReport, setDataReport] = useState<any>({});

  const [dataReportDetail, setDataReportDetail] = useState<any>({});
  const [dataEmployee, setDataEmployee] = useState<any>({});

  // สถานะสำหรับ #print-ready ให้ Puppeteer ฝั่ง backend waitForSelector ก่อน capture
  const [reportSettled, setReportSettled] = useState(false);
  const [employeeSettled, setEmployeeSettled] = useState(false);
  const [fontsReady, setFontsReady] = useState(false);

  // useEffect(() => {
  //   window.print();
  // }, []);

  useEffect(() => {
    const fonts = (document as any).fonts;
    if (fonts?.ready) {
      fonts.ready.then(() => setFontsReady(true));
    } else {
      setFontsReady(true);
    }
  }, []);

  const getLeaveDetail = async (leave_id: number, token: string) => {
    try {
      const res =
        await OnlineLeaveSubmissionApi.getSingleRequestLeaveSubmissionForPrint(
          leave_id,
          token
        );
      const data = res.data;
      if (data.status < 300 && data.data) {
        setDataReport(res.data?.data);
      } else {
        setDataReport({});
      }
    } catch (error) {
      setDataReport({});
    } finally {
      setReportSettled(true);
    }
  };

  useEffect(() => {
    if (leave_id && token) {
      getLeaveDetail(+leave_id, token);
    } else {
      setReportSettled(true);
    }
  }, [leave_id, token]);

  const getEmployeeDetail = async (id: number, token: string) => {
    try {
      const res = await EmployeeApi.getOneForExport(id, token);
      if (res.status < 300) {
        const data = res.data;

        setDataEmployee(data.data);
      }
    } catch (error) {
      setDataEmployee({});
    } finally {
      setEmployeeSettled(true);
    }
  };

  useEffect(() => {
    if (dataReport && dataReport?.id_employee && token) {
      const newDataDetail = dataReport.leave_detail
        ? JSON.parse(dataReport.leave_detail)
        : "";

      setDataReportDetail(newDataDetail);
      getEmployeeDetail(dataReport?.id_employee, token);
    }
  }, [dataReport, token]);

  // form 11 (ใบขอยกเลิกวันลา): ดึงรายละเอียดใบลาที่ถูกยกเลิกด้วย token จาก URL
  // (ห้ามใช้ API ที่พึ่ง token ใน localStorage — Puppeteer เปิดด้วย context เปล่า)
  const [dataLeaveCancel, setDataLeaveCancel] = useState<any>({});
  const [leaveCancelSettled, setLeaveCancelSettled] = useState(false);

  let leaveCancelId: number | null = null;
  if (formType === "11" && dataReport?.leave_detail) {
    try {
      leaveCancelId =
        JSON.parse(dataReport.leave_detail)?.condition?.leave_request_cancel ??
        null;
    } catch (error) {
      leaveCancelId = null;
    }
  }

  const getLeaveCancelDetail = async (id: number, token: string) => {
    try {
      const res =
        await OnlineLeaveSubmissionApi.getSingleRequestLeaveSubmissionForPrint(
          id,
          token
        );
      const data = res.data;
      if (data.status < 300 && data.data) {
        const leaveData = data.data;
        setDataLeaveCancel({
          leave_id: leaveData.id_leave,
          leave_type_name: leaveData.leave_type?.leave_type_name,
          leave_peroid_date: [
            moment(leaveData.leave_start_date).format("YYYY-MM-DD"),
            moment(leaveData.leave_end_date).format("YYYY-MM-DD"),
          ],
          leave_day: calculateLeavePeriod(
            leaveData.leave_start_date,
            leaveData.leave_end_date
          ),
        });
      } else {
        setDataLeaveCancel({});
      }
    } catch (error) {
      setDataLeaveCancel({});
    } finally {
      setLeaveCancelSettled(true);
    }
  };

  useEffect(() => {
    if (leaveCancelId && token) {
      getLeaveCancelDetail(+leaveCancelId, token);
    }
  }, [leaveCancelId, token]);

  return (
    <div className="a4-page">
      {formType === "01" && (
        <Form01
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {formType === "02" && (
        <Form02
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {formType === "03" && (
        <Form03
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {formType === "04" && (
        <Form04
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {formType === "05" && (
        <Form05
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {/* 06 */}

      {formType === "06" && (
        <Form06
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {/* 07 */}
      {formType === "07" && (
        <Form07
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          // sub_header="มหาวิทยาลัยมหาจุฬาลงกรณราชวิทยาลัย"
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={"อธิการบดี ผ่านรองอธิการบดีฝ่ายบริหาร"}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}
      {formType === "08" && (
        <Form08
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={""}
          data={dataReport}
        />
      )}
      {formType === "09" && (
        <Form09
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={""}
          data={dataReport}
        />
      )}
      {formType === "10" && (
        <Form10
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
        />
      )}

      {formType === "11" && (
        <Form11
          header={
            dataReport
              ? dataReport?.leave_type?.leave_form?.leave_form_name
              : ""
          }
          sub_header=""
          title={dataReport ? dataReport?.leave_type?.leave_type_name : ""}
          send_to={dataReportDetail?.main?.worship ?? ""}
          data={dataReport}
          dataReportDetail={dataReportDetail}
          dataEmployee={dataEmployee}
          dataLeaveCancel={dataLeaveCancel}
        />
      )}

      {(!formType ||
        (formType !== "01" &&
          formType !== "02" &&
          formType !== "03" &&
          formType !== "04" &&
          formType !== "05" &&
          formType !== "06" &&
          formType !== "07" &&
          formType !== "08" &&
          formType !== "09" &&
          formType !== "10" &&
          formType !== "11")) && (
        <p>Please select a valid form from the query string.</p>
      )}
      {/* marker ให้ Puppeteer waitForSelector('#print-ready') — โผล่เมื่อข้อมูล+ฟอนต์พร้อม
          ใช้ opacity ไม่ใช่ display:none เผื่อ backend รอแบบ { visible: true } */}
      {reportSettled &&
        fontsReady &&
        (employeeSettled || !dataReport?.id_employee) &&
        (leaveCancelSettled || !leaveCancelId) && (
          <div
            id="print-ready"
            style={{ position: "fixed", width: 1, height: 1, opacity: 0 }}
          />
        )}
      <div className="page-number"></div>
    </div>
  );
};

export default PrintOnlineLeaveSubmission;
